import { useSettings } from '../useSettings'
import { ModuleDto, ModuleType } from '../../context/GlobalContext'
import { useMemo } from 'react'

export type ModulesProps = {
    loaded: boolean
    modules?: ModuleDto[]
    has: (type: ModuleType) => boolean
    any: (types: ModuleType[]) => boolean
    fileModuleSize: () => number
}

export default function useModules(): ModulesProps {
    const settings = useSettings()
    const loaded = useMemo(() => settings?.modules !== undefined, [settings, settings?.modules])

    return {
        loaded,
        modules: settings?.modules,
        has: (type: ModuleType) => settings?.modules?.some(value => value.type === type),
        any: (types: ModuleType[]) =>
            types.map(type => settings?.modules?.some(value => value.type === type)).reduce((a, b) => a || b),
        fileModuleSize: () => settings?.modules?.filter(module => module.fileModule).length,
    }
}
